// import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'PAD_DETAIL';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filters: {
    term: '',
    data: []
  }
});

// const sort = function (a, b) {
//   let result = sortNumber(a.status, b.status);
//   if (result !== 0) {
//     return result;
//   }
//   const aName = a.name || null;
//   const bName = b.name || null;
//   result = sortString(aName, bName);
//   if (result !== 0) {
//     return result;
//   }
//   return sortString(a.key, b.key);
// };

// const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

// const filterData = (data, term) => {
//   const result = data.filter(item => {
//     const product = item.product.name ? filterByTerm(item.product.name, term) : false;
//     const patient = item.patient.name ? filterByTerm(item.patient.name, term) : false;
//     const client = item.client.name ? filterByTerm(item.client.name, term) : false;
//     const status = item.padStatus.name ? filterByTerm(item.padStatus.name, term) : false;

//     return product || patient || status || client;
//   });
//   if (sort) {
//     result.sort(sort);
//   }

//   return result;
// };

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: newData,
        filters: {
          ...state.filters,
          data: newData
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
